import React from 'react';
import { CTAButton } from '../CTAButton';
import { UrgencyBlock } from '../UrgencyBlock';
const stack = [{
  label: '📘 Collezione Protocollo Clinico Sicuro™ (6 Tomi Premium)',
  value: 'USD $97'
}, {
  label: '🎁 5 Bonus Esclusivi',
  value: 'USD $197'
}];
const perks = ['Pagamento unico', 'Accesso a vita', 'Nessuna mensilità', 'Download immediato'];
export function Offer() {
  return <section id="offerta" className="bg-cream px-4 py-14 sm:px-6 sm:py-20" data-id="element-165" data-mp="3a68jdr668gc7">
      <div className="mx-auto w-full max-w-2xl" data-id="element-166" data-mp="3f4jq3t166aq7">
        <p className="text-center text-[11px] font-bold uppercase tracking-[0.2em] text-gold-dark" data-id="element-167" data-mp="3f38n3vfjt705">
          🏆 Offerta speciale di lancio
        </p>
        <h2 className="mt-3 text-center font-display text-[26px] font-bold leading-[1.15] text-ink sm:text-4xl" data-id="element-168" data-mp="3nwlrpumz5x22">
          Questo è tutto ciò che riceverai oggi
        </h2>

        <div className="mt-7 overflow-hidden rounded-3xl border border-ink/10 bg-white shadow-[0_30px_60px_-45px_rgba(14,17,22,0.8)]" data-id="element-169" data-mp="3stu1p7xyyus8">
          <div className="p-6 sm:p-8" data-id="element-170" data-mp="1klztv9yo5ol8">
            <ul className="divide-y divide-ink/10" data-id="element-171" data-mp="1kn1g8al4xxi9">
              {stack.map(item => <li key={item.label} className="flex items-start justify-between gap-4 py-3.5" data-id="element-172" data-mp="1fllro8jr18v4">
                  <span className="text-[14.5px] leading-snug text-ink/80" data-id="element-173" data-mp="16lys7sakyd4p">
                    {item.label}
                  </span>
                  <span className="shrink-0 text-[14px] font-bold text-ink/45 line-through" data-id="element-174" data-mp="23awoxg1w4l4i">
                    {item.value}
                  </span>
                </li>)}
            </ul>
            <div className="mt-2 flex items-center justify-between gap-4 border-t-2 border-ink/15 pt-4" data-id="element-175" data-mp="1uimf3zuwqhns">
              <span className="text-[13px] font-extrabold uppercase tracking-[0.12em] text-ink" data-id="element-176" data-mp="1pjrwoz0uqv47">
                Valore totale
              </span>
              <span className="font-display text-xl font-bold text-ink/50 line-through" data-id="element-177" data-mp="2i98mrq101zx9">
                USD $294
              </span>
            </div>
          </div>

          <div className="bg-ink px-6 py-8 text-center sm:px-8" data-id="element-178" data-mp="31690viquzjld">
            <p className="text-[12px] font-semibold uppercase tracking-[0.14em] text-cream/55" data-id="element-179" data-mp="363inkqmv5h5i">
              Oggi puoi ottenere l’accesso completo per soli…
            </p>
            <p className="mt-2 font-display text-[56px] font-bold leading-none text-gold sm:text-7xl" data-id="element-180" data-mp="2weio764g8jqs">
              USD $27
            </p>

            <ul className="mt-5 flex flex-wrap items-center justify-center gap-x-3 gap-y-2" data-id="element-181" data-mp="2ie7rvnkdecy8">
              {perks.map(perk => <li key={perk} className="rounded-full border border-gold/25 px-3 py-1 text-[11.5px] font-semibold text-cream/75" data-id="element-182" data-mp="2nbpvqzjj61zd">
                  {perk}
                </li>)}
            </ul>

            <p className="mx-auto mt-5 max-w-md text-[14px] leading-relaxed text-cream/65" data-id="element-183" data-mp="7o9c7pj69uby">
              Per meno di quanto costa una cena fuori, avrai una biblioteca
              professionale da consultare ogni volta che affronti un caso
              complesso.
            </p>

            <div className="mt-6" data-id="element-184" data-mp="1s60dg1f0ovzm">
              <CTAButton label="Voglio il Protocollo Clinico Sicuro" note="Pagamento unico di USD $27 · Download immediato · Garanzia di 7 giorni" data-id="element-185" data-mp="1s6tjt1a2djh8" />
            </div>

            <div className="mt-6" data-id="element-186" data-mp="213u7f5pb7djm">
              <UrgencyBlock data-id="element-187" data-mp="2fts0o023itfo" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}